import Select from 'components/Form/Select'
import GroupPeopleIcon from 'components/icons/GroupPeopleIcon'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import {
  AddClgDiv,
  ShortListDiv,
  ShortlistDiv,
  ShortlistFlex,
} from 'modules/Roles/ViewRole/DriveDrawers/Style/style'
import {
  BorderedDiv,
  FlexWrap,
  GreyText,
  MediumText,
  StyledDivider,
} from 'modules/Users/Partials/ViewUserRoleDrawer/Style/style'
import React, { Fragment } from 'react'
import { COLORS } from 'theme'
import { RoleNameDiv, ShortListFlex } from '../../../Style/style'
import { StyledGroup } from '../../ShortListDrawer/Partials'

const AddUserForm = ({
  applyFilter,
  candidateRangeMin,
  candidateRangeMax,
  appliedCandidatesListTrue,
  degreeDepartment,
  singleRoleData,
  studentRating,
  locationStatus,
  selectedRows,
  prefferedlocationStatus,
  currentLocationStatus,
  citySave,
}) => {
  return (
    <Fragment>
      <BorderedDiv>
        <ShortListDiv>
          <ShortListFlex alignCenter>
            <RoleNameDiv>{singleRoleData?.tittle}</RoleNameDiv>
            <RoleStatus status={singleRoleData?.status} />
          </ShortListFlex>
        </ShortListDiv>
        <StyledDivider />
        <MediumText color={COLORS.GREY_T_20} marginbottom={'15px'}>
          Eligible Candidates
        </MediumText>
        <FlexWrap gap="15px" column>
          <>
            <FlexWrap alignCenter>
              <GreyText width="30%" color={COLORS.GREY_T_30}>
                {'By Rating'}
              </GreyText>
              <MediumText>
                {studentRating ? `Above ${studentRating}` : '-'}
              </MediumText>
            </FlexWrap>

            <FlexWrap alignCenter>
              <GreyText width="30%" color={COLORS.GREY_T_30}>
                {'Experience'}
              </GreyText>
              <MediumText>
                {candidateRangeMin !== undefined &&
                candidateRangeMin !== null &&
                candidateRangeMax !== undefined &&
                candidateRangeMax !== null
                  ? `${candidateRangeMin} - ${candidateRangeMax} Yrs`
                  : '-'}
              </MediumText>
            </FlexWrap>

            <FlexWrap alignCenter>
              <GreyText width="30%" color={COLORS.GREY_T_30}>
                {'Degree'}
              </GreyText>
              <MediumText>
                {degreeDepartment?.toString()?.replace(/,/g, ',  ') || '-'}
              </MediumText>
            </FlexWrap>
          </>
        </FlexWrap>
        {(prefferedlocationStatus || currentLocationStatus) &&
          singleRoleData?.cities && (
            <>
              <div style={{ marginTop: '30px' }}>
                <StyledGroup
                  options={[
                    {
                      label: 'Preferred Location',
                      value: 'PREFFERED_LOCATION',
                    },
                    {
                      label: 'Current Location',
                      value: 'CURRENT_LOCATION',
                    },
                  ]}
                  value={locationStatus}
                  disabled={true}
                />
              </div>

              <div style={{ marginTop: '30px' }}>
                <Select
                  value={citySave}
                  placeholder="Select Preferred Location"
                  mode={'multiple'}
                  valueParam="name"
                  disabled={true}
                />
              </div>
            </>
          )}
      </BorderedDiv>

      <AddClgDiv>
        <ShortlistFlex
          background={
            appliedCandidatesListTrue?.count > 0 ? '#eff8f4' : COLORS.RED_T_92
          }
        >
          <GroupPeopleIcon
            color={appliedCandidatesListTrue?.count > 0 ? '#5DB594' : 'red'}
          />
          {appliedCandidatesListTrue?.count ? (
            <ShortlistDiv>
              {applyFilter
                ? appliedCandidatesListTrue?.result?.length
                : selectedRows?.length}
              &nbsp;
              {appliedCandidatesListTrue?.count == '1'
                ? 'candidate'
                : 'candidates'}
              &nbsp; shortlisted for this drive.
            </ShortlistDiv>
          ) : (
            <ShortlistDiv>
              No candidates shortlisted for this drive.
            </ShortlistDiv>
          )}
        </ShortlistFlex>
      </AddClgDiv>
    </Fragment>
  )
}

export default AddUserForm
